import { Contribution, ContributionInvestment } from './api';

export const contributionFilterKeys = ['Portfolio'] as const;

// Stored statuses are single words; only display needs the spaced label.
const STATUS_LABELS: Record<string, string> = {
  PartiallyAllocated: 'Partially Allocated',
};

export const investmentStatusLabel = (
  status: ContributionInvestment['status'] | undefined,
): string => (status ? STATUS_LABELS[status] || status : '');

export const getTotalInvestments = (c: Contribution[]): number => {
  let result = 0;
  for (const contribution of c) {
    result += contribution.investments.length;
  }
  return result;
};
